import React from "react";
import ModalSelecionar from "./ModalSelecionar";

function formatarData(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "—" : d.toLocaleDateString("pt-BR");
}

const COLUNAS = [
  { header: "Nome", render: (t) => t.nome ?? "—", destaque: true },
  { header: "Arquivo", render: (t) => t.nomeArquivoOriginal ?? "—" },
  { header: "Upload", render: (t) => formatarData(t.dataUpload) },
];

export default function ModalSelecionarTemplate(props) {
  return <ModalSelecionar titulo="Selecionar Template" endpoint="/api/templates" placeholder="Nome do template…" colunas={COLUNAS} {...props} />;
}
